import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { formatearMonto } from '../../helpers/helper'
import { buscarUnidad } from '../../servicios/publicacionesService'
import Input from '../../ui/Input'
import InputLabel from '../../ui/InputLabel'
import Select from '../../ui/Select'

const MAX_PORC_CAMBIO = 99
const PRECIO_MAYORISTA_ID_TEM = 10000000

const CambioPrecio = ({
  idPublicacion,
  value: precioUnitario,
  monedaSimbolo,
  onChangeState,
  onChangePorcentaje,
  isDisabled,
  alicuota,
  precioMayorista
}) => {
  const [id, setId] = useState(0)
  const [precioOriginal, setPrecioOriginal] = useState(0)
  const [porcCambio, setPorcCambio] = useState(0)
  const [importeCambio, setImporteCambio] = useState(0)
  const [preciosMayorista, setPreciosMayorista] = useState([])
  const [unidades, setUnidades] = useState([])

  const handleChangePorcentaje = (porcCambio) => {
    let valor = isNaN(porcCambio) || porcCambio === '' ? 0 : parseFloat(porcCambio)
    if (valor < 0) {
      valor = 0
    }
    if (valor > MAX_PORC_CAMBIO) {
      valor = MAX_PORC_CAMBIO
    }
    setPorcCambio(valor)
    setImporteCambio(precioOriginal)
    const nuevoPrecio =
      valor === 0 ? precioOriginal : precioOriginal + (valor * precioOriginal) / 100
    onChangeState('precioUnitario', nuevoPrecio)
  }

  const handleChangeImporte = (importe) => {
    let nuevoPrecio =
      isNaN(importe) || importe === '' ? precioOriginal : parseFloat(importe)
    if (nuevoPrecio <= 0) {
      nuevoPrecio = precioOriginal
    }
    setImporteCambio(nuevoPrecio)
    setPorcCambio(0)
    onChangeState('precioUnitario', nuevoPrecio)
  }

  useEffect(() => {
    if (idPublicacion !== id || (precioOriginal === 0 && precioUnitario !== undefined)) {
      setId(idPublicacion)
      setPorcCambio(0)
      if (precioUnitario !== undefined) {
        setPrecioOriginal(precioUnitario)
        setImporteCambio(precioUnitario)
      } else {
        setImporteCambio(0)
      }
    }
  }, [idPublicacion, id, precioOriginal, precioUnitario, onChangePorcentaje])

  const buscarUnidades = async () => {
    const unidadesRtn = await buscarUnidad()
    setUnidades(unidadesRtn.data)
  }
  useEffect(() => {
    unidades.length === 0 && buscarUnidades()
    setPreciosMayorista(precioMayorista)
  }, [precioMayorista])

  let disabled
  if (isDisabled) {
    disabled = 'disabled'
  }
  const handleChangeAlicuota = (alicuota) => {
    onChangeState(
      'alicuota',
      isNaN(alicuota) || alicuota === '' ? 0 : parseFloat(alicuota)
    )
  }

  const onChange = ({ target }, idPublicacionPrecioMayorista) => {
    const { value, name } = target
    const valueInt = parseInt(value)
    let precios
    if (precioMayorista.length === 1) {
      precios = [{ ...precioMayorista[0], [name]: valueInt > 0 ? valueInt : 0 }]
    } else {
      precios = preciosMayorista.map((element) => {
        return element.idPublicacionPrecioMayorista === idPublicacionPrecioMayorista
          ? {
              ...element,
              [name]: valueInt > 0 ? valueInt : 0
            }
          : element
      })
    }
    onChangeState('preciosMayorista', precios)
    setPreciosMayorista(precios)
  }

  const agregarPrecioMayorista = () => {
    const primeraUnidad =
      preciosMayorista && preciosMayorista.length > 0 ? preciosMayorista[0] : {}

    const nuevo = {
      idPublicacionPrecioMayorista: Math.floor(Math.random() * PRECIO_MAYORISTA_ID_TEM),
      idPublicacion: 0,
      cantidad: 0,
      precio: 0,
      idUnidadMedida: primeraUnidad.idUnidadMedida ?? null,
      unidad: primeraUnidad.unidad ?? ''
    }

    const nuevos = [...preciosMayorista, nuevo]

    setPreciosMayorista(nuevos)
    onChangeState('preciosMayorista', nuevos)
  }

  return (
    <div className="d-flex align-items-center flex-wrap gap-5">
      <div className="d-flex align-items-center me-4">
        <span className="me-2">Por porcentaje</span>
        <Input
          type="number"
          name="porcCambio"
          value={porcCambio}
          onChange={(e) => handleChangePorcentaje(e.target.value)}
          className="text-oferta"
          disabled={disabled}
          style={{ width: '80px' }}
        />
        <i className="fa fa-percent ms-1" aria-hidden="true" />
      </div>
      <div className="d-flex align-items-center me-4">
        <span className="me-2">Por Importe</span>
        <i className="fa fa-dollar me-1" aria-hidden="true" />
        <Input
          type="number"
          name="importeCambio"
          value={importeCambio}
          onChange={(e) => handleChangeImporte(e.target.value)}
          className="text-oferta"
          disabled={disabled}
          style={{ width: '100px' }}
        />
      </div>
      <div className="d-flex align-items-center me-4">
        <span className="me-2">Alicuota</span>
        <Input
          type="number"
          name="alicuota"
          value={alicuota}
          onChange={(e) => handleChangeAlicuota(e.target.value)}
          className="text-oferta"
          disabled={disabled}
          step="0.1"
          style={{ width: '80px' }}
        />
      </div>
      <div className="d-block">{formatearMonto(precioUnitario, monedaSimbolo)}</div>
      <div>
        <div className="d-block mt-2 mb-2 font-weight-bold ">Precio mayorista</div>
        <button
          className="btn btn-primary mb-3"
          type="button"
          onClick={agregarPrecioMayorista}
        >
          + Agregar precio mayorista
        </button>
        {preciosMayorista?.length > 0 &&
          preciosMayorista.map((mayorista, index) => (
            <div className="row mb-3" key={index}>
              <div className="col-12 col-sm-6 d-flex align-items-center">
                <div className="col-4">Cantidad</div>
                <div className="col w-25">
                  <InputLabel
                    type="number"
                    name="cantidad"
                    value={mayorista?.cantidad || 0}
                    onChange={(e) => onChange(e, mayorista.idPublicacionPrecioMayorista)}
                    classNameInput="publicacion-precio-mayorista"
                    error="Completar Precio Mayorista Cantidad"
                    onFocusSelected
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 d-flex align-items-center mt-2 mt-sm-0">
                <div className="col-4">
                  Precio Unitario <i className="fa fa-usd ml-1" aria-hidden="true" />
                </div>
                <div className="col w-25">
                  <InputLabel
                    type="number"
                    name="precio"
                    value={mayorista.precio || 0}
                    onChange={(e) => onChange(e, mayorista.idPublicacionPrecioMayorista)}
                    classNameInput="publicacion-precio-mayorista"
                    error="Completar Precio Mayorista Unitario"
                    onFocusSelected
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 d-flex align-items-center mt-2 mt-sm-0">
                <span className="mt-4 mr-2"> Unidad: </span>
                <div className="w-50 h-25">
                  <Select
                    name="idUnidadMedida"
                    value={mayorista.idUnidadMedida || 0}
                    onChange={(e) => onChange(e, mayorista.idPublicacionPrecioMayorista)}
                    className="select-publicacion unidad-publicacion"
                    datos={unidades}
                    optionMetaDatos={{ value: 'idUnidadMedida', text: 'nombre' }}
                    optionPorDefecto={{ value: '0', text: 'Seleccionar' }}
                  />
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

CambioPrecio.propTypes = {
  idPublicacion: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  monedaSimbolo: PropTypes.string.isRequired,
  onChangeState: PropTypes.func.isRequired,
  onChangePorcentaje: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  alicuota: PropTypes.number.isRequired,
  precioMayorista: PropTypes.arrayOf(
    PropTypes.shape({
      cantidad: PropTypes.number.isRequired,
      precio: PropTypes.number.isRequired,
      unidad: PropTypes.string.isRequired
    })
  )
}

export default CambioPrecio
